import React, { useEffect } from "react";
import WebFont from "webfontloader";

export const NavTitle = (props) => {
  //   const scrlpos = props.data.props.props;
  useEffect(() => {
    WebFont.load({
      google: {
        families: ["Macondo"],
      },
    });
  }, []);
  const style = {
    fontFamily: "Macondo",
    fontSize: "3rem",
  };
  //   style={scrlpos > 50 ? darkStyle : headStyle}
  return <h2 style={style}>&#9999;LazyDev</h2>;
};
